<div class="col-12 p1">
  @if (isOpenNow) {
    <p>
      <span class="col-3 p-r-9 pos-relative dot"
        translate>Open
      </span>@if (store.todayOpeningHours) {
      <span>
        {{ 'Closes at' | translate}} {{store.todayOpeningHours.close | hourFormat12 : ''}}
      </span>
    }
  </p>
}
@if (!isOpenNow) {
  <p>
    <span class="col-2 p-r-9 pos-relative dot"
      translate>Closed
    </span>@if (nextOpenStatus) {
    <span>
      {{ 'Opens' | translate}}&nbsp;{{nextOpenStatus}}
    </span>
  }
</p>
}
</div>